import { useState, useEffect } from 'react'
import { ScoutQuery, ScoutQueryCreate } from '../../services/scout.service'

interface Props {
  editingQuery?: ScoutQuery | null
  onSubmit: (data: ScoutQueryCreate) => void
  onCancel: () => void
}

export default function ScoutQueryForm({ editingQuery, onSubmit, onCancel }: Props) {
  const [queryText, setQueryText] = useState('')
  const [minSubscribers, setMinSubscribers] = useState(0)
  const [businessContext, setBusinessContext] = useState('')
  const [keywordsText, setKeywordsText] = useState('')
  const [scheduleHours, setScheduleHours] = useState(6)
  const [searchTypes, setSearchTypes] = useState('all')

  useEffect(() => {
    if (editingQuery) {
      setQueryText(editingQuery.query_text)
      setMinSubscribers(editingQuery.min_subscribers)
      setBusinessContext(editingQuery.business_context || '')
      const kw = editingQuery.target_keywords ? JSON.parse(editingQuery.target_keywords) as string[] : []
      setKeywordsText(kw.join(', '))
      setScheduleHours(editingQuery.schedule_hours)
      setSearchTypes(editingQuery.search_types || 'all')
    }
  }, [editingQuery])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const keywords = keywordsText
      .split(',')
      .map(k => k.trim())
      .filter(Boolean)

    onSubmit({
      query_text: queryText,
      min_subscribers: minSubscribers,
      business_context: businessContext || undefined,
      target_keywords: keywords.length > 0 ? keywords : undefined,
      schedule_hours: scheduleHours,
      search_types: searchTypes,
    })
  }

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-lg border p-5 space-y-4">
      <h3 className="font-semibold text-gray-900">
        {editingQuery ? 'Редактировать запрос' : 'Новый поисковый запрос'}
      </h3>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Поисковый запрос</label>
        <input
          type="text"
          value={queryText}
          onChange={e => setQueryText(e.target.value)}
          placeholder="crypto trading, web3 маркетинг..."
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Контекст бизнеса</label>
        <textarea
          value={businessContext}
          onChange={e => setBusinessContext(e.target.value)}
          placeholder="Что вы продаёте, кого ищете..."
          rows={2}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Ключевые слова (через запятую)
        </label>
        <input
          type="text"
          value={keywordsText}
          onChange={e => setKeywordsText(e.target.value)}
          placeholder="разработка, дизайн, маркетинг"
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
        />
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Тип поиска</label>
          <select
            value={searchTypes}
            onChange={e => setSearchTypes(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="all">Все</option>
            <option value="channels">Только каналы</option>
            <option value="groups">Только группы/чаты</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Мин. подписчиков</label>
          <input
            type="number"
            value={minSubscribers}
            onChange={e => setMinSubscribers(Number(e.target.value))}
            min={0}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Частота (часы)</label>
          <select
            value={scheduleHours}
            onChange={e => setScheduleHours(Number(e.target.value))}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          >
            <option value={1}>Каждый час</option>
            <option value={3}>Каждые 3 часа</option>
            <option value={6}>Каждые 6 часов</option>
            <option value={12}>Каждые 12 часов</option>
            <option value={24}>Раз в сутки</option>
          </select>
        </div>
      </div>

      <div className="flex gap-2 pt-2">
        <button
          type="submit"
          className="px-4 py-2 bg-primary-600 text-white text-sm rounded-lg hover:bg-primary-700"
        >
          {editingQuery ? 'Сохранить' : 'Создать'}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 text-gray-700 text-sm rounded-lg hover:bg-gray-50"
        >
          Отмена
        </button>
      </div>
    </form>
  )
}
